import React, {useRef, useState} from 'react';
import {useDispatch} from 'react-redux';

import {notifyUser} from 'modules/toast/actions';
import {cancelPasswordReset, submitNewPassword} from 'modules/authentication/actions';
import {passwordRequirementMessages, validatePassword} from 'modules/authentication/utils';

import CancelAndContinueButtons from 'components/Authentication/Controls/CancelAndContinueButtons';
import PasswordField from 'components/Authentication/Controls/PasswordField';
import ValidationMark from 'components/Authentication/Controls/ValidationMark';
import AuthenticationContainer from 'components/Authentication/Steps/AuthenticationContainer';


export default function ResetPassword() {

    const dispatch = useDispatch();
    const passwordRef = useRef(null);
    const confirmRef = useRef(null);

    const [passwordValidation, setPasswordValidation] = useState({});

    const handlePasswordChange = () => {
        const password = passwordRef.current.value;
        const validationResults = validatePassword(password);
        setPasswordValidation(validationResults);
    };

    const continueAction = () => {

        const password = passwordRef.current.value;
        const confirm = confirmRef.current.value;

        const validationResults = validatePassword(password);

        if (!validationResults.valid) {
            dispatch(notifyUser('The new password is not complex enough', 'error'));
            return;
        }

        if (password != confirm) {
            dispatch(notifyUser('The new password and confirmation password did not match', 'error'));
            return;
        }

        dispatch(submitNewPassword(password, confirm));
    };

    const cancelAction = () => {
        dispatch(cancelPasswordReset());
    };

    const requirementsStyles = {
        marginTop: 10,
        marginBottom: 30
    }

    const requirementButtonStyles = {
        paddingTop: 3,
        paddingBottom: 3,
        cursor: 'pointer',
        width: 'fit-content'
    }

    const requirementItemStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        margin: '5px 0',
    };

    const renderRequirementItem = (key) => {
        const isValid = passwordValidation.tests && passwordValidation.tests[key];
        return (
            <li key={key} style={requirementItemStyle}>
                <ValidationMark isValid={isValid}/>
                {passwordRequirementMessages[key]}
            </li>
        );
    };

    const requirementsList = Object.keys(passwordRequirementMessages).map(renderRequirementItem);

    const passwordIsValid = passwordValidation.valid;

    return <AuthenticationContainer title="Reset Password">
        <p>Please enter your new password into both text boxes.</p>

        <PasswordField inputRef={passwordRef} onChange={handlePasswordChange}/>
        <PasswordField inputRef={confirmRef} label="Confirm Password" />

        <details style={requirementsStyles}>
            <summary style={requirementButtonStyles}>Password requirements met: <ValidationMark isValid={passwordIsValid}/></summary>
            <p>Your password must meet the following requirements:</p>

            <ul style={{padding: '0'}}>
                {requirementsList}
            </ul>
        </details>

        <CancelAndContinueButtons cancelAction={cancelAction} continueAction={continueAction}/>
    </AuthenticationContainer>;

}